import { render, staticRenderFns } from "./CompanyDrawerAdditionalDataChar.vue?vue&type=template&id=93785bb0&"
import script from "./CompanyDrawerAdditionalDataChar.vue?vue&type=script&lang=ts&"
export * from "./CompanyDrawerAdditionalDataChar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports